import './MktgTestimonies.css'

export default function MktgTestimonies() {
  return (
    <div>MktgTestimonies</div>
  )
}
